import { useState } from "react";
import { useParams } from "react-router";
import { useTranslate } from "@refinedev/core";

import {
  useGetPartnerQuery,
  usePartnerDetailSummaryQuery,
  usePartnerHistoryQuery,
  usePartnerMonthlyQuery,
  usePartnerReferralsQuery,
} from "@modules/partners/services/queries";
import {
  useApprovePartnerMutation,
  useRejectPartnerMutation,
} from "@modules/partners/services/mutations";

export function usePartnerDetail() {
  const { id } = useParams();
  const translate = useTranslate();
  const [tab, setTab] = useState<"summary" | "referrals" | "monthly" | "history">(
    "summary"
  );
  const [rejectOpen, setRejectOpen] = useState(false);

  const { data: partner, isLoading, refetch } = useGetPartnerQuery(id);
  const { data: summary } = usePartnerDetailSummaryQuery(id);
  const { data: referrals } = usePartnerReferralsQuery(id);
  const { data: monthly } = usePartnerMonthlyQuery(id);
  const { data: history } = usePartnerHistoryQuery(id);

  const approveMutation = useApprovePartnerMutation();
  const rejectMutation = useRejectPartnerMutation();

  const handleApprove = async () => {
    if (!partner) return;
    await approveMutation.mutateAsync(partner.id);
    refetch();
  };

  const handleReject = async (reason: string) => {
    if (!partner) return;
    await rejectMutation.mutateAsync({
      id: partner.id,
      rejection_reason: reason,
    });
    setRejectOpen(false);
    refetch();
  };

  return {
    id,
    tab,
    setTab,
    partner,
    isLoading,
    summary,
    referrals,
    monthly,
    history,
    rejectOpen,
    setRejectOpen,
    isRejecting: rejectMutation.isPending,
    handleApprove,
    handleReject,
    translate,
  };
}
